import moment from "moment";
import React from "react";
import Skeleton from "react-loading-skeleton";

import formatCurrency from "../../../utils/formatCurrency";
import SafeECharts from "../../stats/SafeECharts";
moment.locale("en");

const months = Array.from(Array(12), (_, i) => moment(i + 1, "M").format("MMM"));

interface MonthlyReferrersEarningsGraphProps {
  data?: Record<string, Record<string, number>>;
  currency: string;
  isLoading?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const MonthlyReferrersEarningsGraph: React.FC<MonthlyReferrersEarningsGraphProps> = ({
  data = {},
  currency,
  isLoading = false,
  style,
  className,
}) => {
  if (isLoading) return <Skeleton height={style?.height ?? 400} />;
  return (
    <SafeECharts
      className={className}
      style={style}
      option={{
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              formatter: ({ value }: { value: string }) => moment(value, "MMM").format("MMMM"),
            },
          },
        },
        grid: {
          containLabel: true,
          top: 15,
          right: 10,
          left: 10,
          bottom: 10,
        },
        yAxis: {
          type: "value",
          axisLabel: { formatter: (n: number) => formatCurrency(n, currency) },
        },
        xAxis: {
          type: "category",
          data: months,
        },
        legend: {
          data: Object.keys(data),
        },
        series: Object.entries(data).map(([name, perMonth]) => ({
          name,
          type: "bar",
          tooltip: { valueFormatter: (n: number) => formatCurrency(n, currency) },
          emphasis: { focus: "series" },
          barGap: 0,
          data: Object.entries(perMonth).reduce<number[]>(
            (r, [month, total]) => {
              r[Number(month) - 1] = total;
              return r;
            },
            Array.from(Array(12), () => 0)
          ),
        })),
      }}
      notMerge
    />
  );
};

export default MonthlyReferrersEarningsGraph;
